import { render, staticRenderFns } from "./ValidateProjectMasjidtanah.vue?vue&type=template&id=36003faf&scoped=true&lang=pug&"
import script from "./ValidateProjectMasjidtanah.vue?vue&type=script&lang=js&"
export * from "./ValidateProjectMasjidtanah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36003faf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VForm,VTextField})
